import {Table} from "antd";
import React from "react";
import getColumns from "./licenceColumns";
import LicenceDatatableContainer from "./LicenceDatatable.style";
import LicenceElements from "../LicenceElements";
import {useController} from "./LicenceDatatable.controller";

const LicenceDatatable = ({
                              data, loading, primaryColor, darkMode, onRevokeClick, onDeleteClick, onPublicKeyDownload, onLicenceSend,
                              onSendPassword, onLicenceDownload, companyOptions, showLicenceInfo,
                              toggleLicenceDetails, licenceToShowDetailsFor, licenceDetailsVisible,
                              softwareProductOptions
                          }) => {

    const {filterLicences, filteredLicences} = useController();

    const updateFiltersMap = (key, type, value) => {
        filterLicences({key, value, type});
    };

    const columns = getColumns({
        primaryColor,
        onRevokeClick,
        onDeleteClick,
        onLicenceSend,
        showLicenceInfo,
        onSendPassword,
        toggleLicenceDetails, licenceToShowDetailsFor, licenceDetailsVisible,
        onLicenceDownload,
        onPublicKeyDownload,
        updateFiltersMap,
        companyOptions,
        softwareProductOptions,
        darkMode
    });

    return <LicenceDatatableContainer darkMode={darkMode} primaryColor={primaryColor}>
        <Table rowKey="id"
               loading={loading}
            // bordered
               className="main-table"
               expandable={{
                   expandedRowRender: record => {
                       return <LicenceElements record={record}/>

                   },
                   rowExpandable: record => !!record.content,
               }}
               scroll={{
                   y: window.innerHeight - 280,
                   scrollToFirstRowOnChange: true
               }} // TODO check how to fix scrolling
               size="small"
               rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
               pagination={{pageSizeOptions: ['10', '20', '50'], showSizeChanger: true}}
               onRow={(record, rowIndex) => {
                   return {
                       onClick: event => {
                       }, // click row
                       onDoubleClick: event => {
                       }, // double click row
                       onContextMenu: event => {
                       }, // right button click row
                       onMouseEnter: event => {
                       }, // mouse enter row
                       onMouseLeave: event => {
                       }, // mouse leave row
                   };
               }}
               columns={columns}
               dataSource={filteredLicences}/>
    </LicenceDatatableContainer>
};

export default LicenceDatatable;